import React from 'react';
import ResponsiveLayout, {
  AnchorPosition,
} from '../../components/common/ResponsiveLayout';
import OtpFlow from '../../components/preview/OtpFlow';

const OtpRequestPage: React.FC = () => {
  return (
    <ResponsiveLayout anchor={AnchorPosition.TOP_RIGHT}>
      <OtpFlow />
    </ResponsiveLayout>
  );
};

export default OtpRequestPage;
